import { render, staticRenderFns } from "./NetworkingMessages.vue?vue&type=template&id=c0afda00&scoped=true"
import script from "./NetworkingMessages.vue?vue&type=script&lang=js"
export * from "./NetworkingMessages.vue?vue&type=script&lang=js"
import style0 from "./NetworkingMessages.vue?vue&type=style&index=0&id=c0afda00&prod&lang=scss&scoped=true"
import style1 from "./NetworkingMessages.vue?vue&type=style&index=1&id=c0afda00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0afda00",
  null
  
)

export default component.exports